// src/components/VisActor.js
import React from 'react';
import { ArrowRightCircle } from 'react-feather';

// It now receives the onReady function from its parent
export default function VisActor({ onReady }) {
  return (
    <div className="sidebar-footer">
      <button className="ready-to-file-button-sidebar" onClick={onReady}>
        <span>Ready to File</span>
        <ArrowRightCircle size={20} />
      </button>
    </div>
  );
}